import { RiskFactorInfo } from '../../models/risk-factor/risk-factor-info';
import { PlanByTravelWL } from '../../models/plan-by-travel-wl/plan-by-travel-wl';
import { PaymentInfo } from '../../models/payment/payment-info';
import { PolicyContractInfo } from '../../models/policy-contract/policy-contract-info';

/**
 * リクエスト
 */
export class CollateralDisplayRequest {
	public transactionDate	: string 			= null; // トランザクション日時
	public riskFactorInfo	: RiskFactorInfo 	= null; // リスクファクタ情報
	public planCode			: String 			= null; // プランコード
	public paymentInfo		: PaymentInfo 		= null; // 支払情報
	public coverageCodeList	: string[]					// 担保種目キーリスト
	public policyContractInfo   : PolicyContractInfo = null;
	public inquiryPw            : string = null;
}